import React, { FC } from 'react';
import cn from 'classnames';

import { dataLayerEvents } from 'client/utils/gtag';

import { CircleRate } from './CircleRate';
import { isMobileOrTablet } from 'client/hooks/responsive';
import { formatRateNumber } from 'client/utils/formatRateNumber';

import css from './GeneralRate.module.scss';

export type RateFromT = 'mako' | 'booking';

type Props = {
  rate: number;
  from: RateFromT;
  url?: string | null;
  className?: string;
  name?: string;
};

const rateResourceColor: Record<RateFromT, string> = {
  mako: '#1CB3BD',
  booking: '#03377C',
};

const GeneralRate: FC<Props> = ({ rate, from, className = '', url, name }) => {
  const isMobile = isMobileOrTablet();

  const rateResourceStyle = {
    color: rateResourceColor[from],
  };

  return (
    <div
      className={cn(
        css[className],
        css.generalRate,
        isMobile && css.mobile,
        isMobile && className && css.onlyMakoMobile,
      )}
    >
      <div className={css.numberRate}>
        <span>{formatRateNumber(rate)}</span>
      </div>
      <div className={css.circleRate}>
        <CircleRate rate={rate} from={from} />
      </div>
      <div className={css.rateResource} style={rateResourceStyle}>
        {url && from === 'booking' ? (
          <a
            href={url}
            target="_blank"
            id="booking"
            rel="nofollow noreferrer"
            onClick={() => name && dataLayerEvents.onBookingClick(name as string)}
          >
            <span>דירוג {from}</span>
          </a>
        ) : (
          <span>דירוג {from}</span>
        )}
      </div>
    </div>
  );
};

export default GeneralRate;
